<template>
    <div id="loading_holder" class="vs-con-loading__container">
        <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
            <div class="vx-col md:w-1/2 lg:w-2/5 m-4">
                <vx-card v-if="loading" class="text-center">
                    <a-spin size="large" class="m-6"/>
                    Carregando dados...
                </vx-card>
                <vx-card v-else class="animate">
                    <Stepper v-model="step" :steps="2">
                        <Welcome slot="1" :company="company" :loading="loading" @proceed="proceed" />
                        <NewUserForm slot="2" :company="company" @userCreated="goToWaitingRoom"/>
                    </Stepper>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import firebase from '@/firebase/firebase';
    import Welcome from './steps/Welcome.vue';
    import NewUserForm from './steps/NewUserForm.vue';
    import Stepper from '../../../components/Stepper.vue';

    export default {
    components: { Welcome, NewUserForm, Stepper },
    props: {
            companyId: String
        },
        watch: {
            user: {
                handler (val) {
                    if (val)
                        this.checkIfThereIsInvite(val);
                },
                immediate: true
            }
        },
        data() {
            return {
                loading: true,
                company: null,
                error: false,
                step: 1
            }
        },
        methods: {
            async fetchCompany () {
                try {
                    this.loading = true;
                    const companySnap = await firebase.firestore().collection('company').doc(this.companyId).get();
                    if (!companySnap.exists) {
                        this.$router.back();
                        return;
                    }
                    this.company = { id: companySnap.id, ...companySnap.data() };
                } catch (err) {
                    console.log(err);
                    this.error = true;
                } finally {
                    this.loading = false;
                }
            },
            proceed () {
                this.step++;
            },
            goToWaitingRoom () {
                this.$router.push(`/waiting-room/${this.companyId}`)
            },
            async checkIfThereIsInvite (user) {
                const { companyId } = this;
                const snap = await firebase.firestore().collection(`company/${companyId}/invites`)
                    .where('user.id', '==', user.id)
                    .get();
                if (snap.size == 0)
                    return;
                const invite = snap.docs[0].data();
                if (invite.pending)
                    this.$router.replace(`/waiting-room/${companyId}`);
                else if (invite.approved) {
                    this.$warning({
                        zIndex: 99999,
                        title: 'Você já faz parte desta empresa!',
                        content: 'Você será redirecionado à pagina pricipal'
                    });
                    this.$router.replace('/');
                }
            }
        },
        computed: mapGetters({ 'user': 'getUserStoredData' }),
        created () {
            this.fetchCompany();
        }
    }
</script>

<style lang="scss" scoped>
.animate {
    transition: all 1s;
}
</style>